import { useState, useCallback } from 'react';

export const useNatureFilter = () => {
  const [selectedNatures, setSelectedNatures] = useState<string[]>([]);

  const handleNatureChange = useCallback((natures: string[]) => {
    setSelectedNatures(natures);
  }, []);

  return {
    selectedNatures,
    handleNatureChange,
  };
};
